import React, { useState, useEffect } from 'react';

import API from 'src/utils/apiCalling';
import { config } from 'src/utils/apiUrl';
import { withRouter } from 'react-router-dom';
import swal from 'sweetalert';
import { toast, ToastContainer } from 'react-toastify';
const OfferLatterDetails = props => {
  let { getEmployeeDetailStatus, empStatus, empDetails, history,onClickActive } = props;
  const api = new API();
  const [visible, setVisible] = useState(false);
  const [candidate, setCandidate] = useState(false);
  const [ctcResult, setCtcResult] = useState();

  useEffect(() => {
    getOnBoardingCtcOfferLatter();
  }, []);

  const getOnBoardingCtcOfferLatter = async () => {
    let data = {
      user_id: empDetails && empDetails.id,
    };
    if (!data.user_id) {
      delete data.user_id;
    }
    let result = await api.get(config.getCandidateCtcJoiningDetail, true, data);
    if (result && result.code == 200) {
      // console.log("succefull getting offer later status data", result.data)
      setCandidate(result.data[0]);
      ctcCalculator(result.data[0].ctc);
    } else {
      // alert('worng');
    }
  };

  const ctcCalculator = async ctc => {
    let data = {
      ctc_amount: ctc,
    };
    let result = await api.post(config.ctcGenerator, data);
    if (result && result.code == 200) {
      setCtcResult(result.data);
    }
  };

  const OfferLetterDecline = async event => {
    let data = {
      user_id: empDetails && empDetails.id,
    };
    if (!data.user_id) {
      delete data.user_id;
    }
    swal({
      html: true,
      title: 'Are your sure to decline offer letter?',
      icon: 'success',
      buttons: ['No, cancel it!', 'Decline'],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        let result = await api.post(config.declineOfferLetter, data);
        if (result && result.code === 200) {
          window.location.href = '/#/';
          localStorage.clear();
          sessionStorage.clear();
        } else {
          // alert('worng');
        }
      }
    });
  };

  const OfferLetterAccept = async (e) => {
    e.preventDefault()
    let data = {
      user_id: empDetails && empDetails.id,
    };
    if (!data.user_id) {
      delete data.user_id;
    }
    swal({
      html: true,
      title: 'Are your sure to accept offer letter?',
      icon: 'success',
      buttons: ['No, cancel it!', 'Accept'],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        let result = await api.post(config.acceptOfferLetter, data);
        if (result && result.code === 200) {
          toast.success("Offer Letter Accepted Successfully");
          onClickActive(2);
          setVisible(true);
          getEmployeeDetailStatus();
        }else{
          setVisible(false);
        }
      }
    });
  };

  return (
    <div className="container-fluid">
      <div className="offer_latter_section text-center">
        <div className="card-body">
          <h3 style={{color:"darkblue"}}>Offer letter has been sent to your registered Email ID</h3>
          <h4 className="mt-3" style={{color:"#ed6826"}}>
            Kindly proceed with your acceptance
          </h4>
          <hr></hr>
          1. What will happen if I click on the <b style={{color:"green"}}>Accept</b> button ?
          <br></br>
          <i>You have accepted this offer letter</i>
          <br></br>
            You will move to the next step where you need to submit necessary
            details and documents

          <hr></hr>
          2. What will happen if I click on the <b style={{color:"red"}}>Decline</b> button ?
          <br></br>
          <i>You have rejected this offer letter</i>
          <br></br>
            This account will get disabled and you can't access this account
            anymore.
        </div>
        {empStatus && empStatus.offer_letter_status === 1 ? (
          <button className="btn btn-success float-right" style={{marginTop:"50px"}} type="button" onClick={(e) => onClickActive(2)}>Next <i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
        ) : (
          <div className="card-footer text-center">
            <button className="btn btn m-3" style={{backgroundColor:"green",color:"white"}} onClick={(e)=>OfferLetterAccept(e)}>
              Accept
            </button>
            <button className="btn btn m-3" style={{backgroundColor:"red",color:"white"}} onClick={OfferLetterDecline}>
              Decline
            </button>
          </div>
        )}
      </div>
      <ToastContainer/>
    </div>
  );
};
export default withRouter(OfferLatterDetails);
